import { render } from "./DiscountDecisionKanban.vue?vue&type=template&id=d88becfe&scoped=true"
import script from "./DiscountDecisionKanban.vue?vue&type=script&lang=js"
export * from "./DiscountDecisionKanban.vue?vue&type=script&lang=js"

import "./DiscountDecisionKanban.vue?vue&type=style&index=0&id=d88becfe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88becfe"]])

export default __exports__